module.exports = __webpack_public_path__ + "static/media/3DPPA43.87a3d3e8.jpg";